export default "__VITE_ASSET__e0a4adc9__"